export const messages = {
  en: {
    invoice_flow__paywise_cash: 'PayWise Cash transfer',
    invoice_flow__paywise_cash_title: 'To pay with PayWise',
    invoice_flow__paywise_cash_steps_step_1: 'Find the nearest <b>PayWise Agent</b>',
    invoice_flow__paywise_cash_steps_step_2:
      'Provide <b>BILLER NAME</b>: <span>{merchant_name}</span>',
    invoice_flow__paywise_cash_steps_step_3:
      'Provide <b>PRODUCT CODE</b>: <span>{product_code}</span>',
    invoice_flow__paywise_cash_steps_step_4: 'Provide <b>BILLING PHONE</b>: <span>{phone}</span>',
    invoice_flow__paywise_cash_steps_step_5: 'Provide <b>INVOICE ID</b>: <span>{invoice_id}</span>',
    invoice_flow__paywise_cash_steps_step_6: 'Pay: <span>{amount} {currency}</span>',
  },
};
